import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Trans } from 'react-i18next';

import useCompatibleDisplay from 'Util/Hooks/useCompatibleDisplay';
import { ButtonFilled, Flex, Text } from 'Components/Base';
import { Modal } from 'Components/Modal';

// --- styles ---
const BulletList = styled.ul`
  margin: 16px 0 0 0;
  padding-left: 22px;
  text-align: left;
  font-size: 14px;
`;

const BulletItem = styled.li`
  margin: 0;
  color: ${({ theme }) => theme.colors?.textColor?.secondary || '#757575'};
  line-height: 1.8;
`;

const FreeTrialCourseEnrollmentPendingModal = ({
  muiProps,
  titleText = 'พี่กำลังเตรียมคอร์สให้นะ',
  subtitleText = 'หากเกิน 30 นาทีแล้วยังไม่ได้รับคอร์สให้ลอง ...',
  tips = [],
  primaryText = 'เข้าใจแล้ว',
  primaryOnClick,
  icon,
}) => {
  const { isMobile } = useCompatibleDisplay();

  const { onClose, isActive, innerProps, modalPaperStyle, ...restMuiProps } = muiProps;

  const handleClose = () => {
    if (typeof primaryOnClick === 'function') primaryOnClick();
    else if (typeof onClose === 'function') onClose();
  };

  return (
    <Modal
      muiProps={{
        isActive,
        modalPaperStyle: { margin: isMobile ? 16 : 32, ...modalPaperStyle },
        innerProps: { padding: 6, ...innerProps },
      }}
      contentWrapperProps={{ padding: '0px !important' }}
      disableTopOffset
      header={
        <Flex alignItems="center" flexDirection="column" gridRowGap={6}>
          {icon}
          <Text fontSize={5} fontWeight={600}>
            {titleText}
          </Text>
        </Flex>
      }
      contents={
        <Flex flexDirection="column">
          <Text color="textColor.secondary" textStyle="body2">
            <Trans defaults={subtitleText} components={<br key="subtitle" />} />
          </Text>

          {Array.isArray(tips) && tips.length > 0 && (
            <BulletList>
              {tips.map((tip, index) => (
                <BulletItem key={index}>{tip}</BulletItem>
              ))}
            </BulletList>
          )}
        </Flex>
      }
      footer={
        <Flex
          justifyContent="flex-end"
          marginTop={6}
          style={{ whiteSpace: 'nowrap', overflow: 'hidden' }}
          flexDirection="column"
        >
          <ButtonFilled color="primary" onClick={handleClose} fontWeight={600} borderRadius={8}>
            {primaryText}
          </ButtonFilled>
        </Flex>
      }
      {...restMuiProps}
    />
  );
};

FreeTrialCourseEnrollmentPendingModal.propTypes = {
  ...Modal.propTypes,
  muiProps: PropTypes.shape({
    isActive: PropTypes.bool,
    onClose: PropTypes.func,
    innerProps: PropTypes.object,
    modalPaperStyle: PropTypes.object,
  }).isRequired,

  titleText: PropTypes.string,
  subtitleText: PropTypes.string,
  tips: PropTypes.arrayOf(PropTypes.string).isRequired,
  primaryText: PropTypes.string,
  primaryOnClick: PropTypes.func,
  icon: PropTypes.node,
};

export default FreeTrialCourseEnrollmentPendingModal;
